import { motion } from "framer-motion";

export const EASE = [0.22, 1, 0.36, 1];

export const REVEAL_VIEWPORT = { once: true, margin: "-70px" };

export const FADE_IN = { initial: { opacity: 0 }, animate: { opacity: 1 }, exit: { opacity: 0 } };

export const COLLAPSE = {
  initial: { height: 0, opacity: 0 },
  animate: { height: "auto", opacity: 1 },
  exit: { height: 0, opacity: 0 },
  transition: { duration: 0.45, ease: EASE },
};

export const SLIDE_UP = {
  initial: { y: 80, opacity: 0 },
  animate: { y: 0, opacity: 1 },
  exit: { y: 80, opacity: 0 },
  transition: { duration: 0.5, ease: EASE },
};

export const Reveal = ({ children, delay = 0, y = 32, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={REVEAL_VIEWPORT}
    transition={{ duration: 0.9, delay, ease: EASE }}
  >
    {children}
  </motion.div>
);

export const Overline = ({ children, dark = false, className = "" }) => (
  <p
    className={`font-mono text-xs tracking-[0.3em] uppercase ${
      dark ? "text-leafmute" : "text-leaf"
    } ${className}`}
  >
    {children}
  </p>
);

export const SectionHead = ({ overline, title, dark = false, className = "" }) => (
  <div className={className}>
    <Reveal>
      <Overline dark={dark}>{overline}</Overline>
    </Reveal>
    <Reveal delay={0.1}>
      <h2
        className={`mt-5 font-serif text-4xl sm:text-5xl lg:text-6xl tracking-tight leading-[1.12] ${
          dark ? "text-ink" : "text-cream"
        }`}
      >
        {title}
      </h2>
    </Reveal>
  </div>
);
